import { h, Component } from "preact";
import { css } from "emotion";

const noResultsImage = require("../../assets/image_no_results.svg");
const wrapper = css({
  textAlign: "center",
  maxWidth: 298,
  marginBottom: 24
});

const NoResults = ({ text, subText }) => {
  return (
    <div className={wrapper}>
      <img src={noResultsImage} alt="Sad computer with a magnifying glass" />
      <h4>{text}</h4>
      <p>{subText}</p>
    </div>
  );
};

export default NoResults;
